import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap";
import "./scss/main.scss";
import { Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Eventos from "./components/Eventos";
import Fechas from "./components/Fechas";
import Inicio from "./components/Inicio";
import Festival from "./components/Festival";
import Trabajos from "./components/Trabajos";
import Contacto from "./components/Contacto";
import Nosotros from "./components/Nosotros";
import Footer from "./components/Footer";
import Acreditacion from "./components/Acreditacion";
import AvisoLegal from "./components/AvisoLegal";
import PoliticaCookies from "./components/PoliticaCookies";
import PoliticaPrivacidad from "./components/PoliticaPrivacidad";
import CondicionesGenerales from "./components/CondicionesGenerales";
import TourDetail from "./components/TourDetail";

const App = () => {
	return (
		<>
			<Nav />
			<Routes>
				<Route exact path='/' element={<Inicio />} />
				<Route
					exact
					path='/eventos'
					element={<Eventos />}
				/>
				<Route
					exact
					path='/fechas'
					element={<Fechas />}
				/>
				<Route
					exact
					path='/inicio'
					element={<Inicio />}
				/>
				<Route
					exact
					path='/festival'
					element={<Festival />}
				/>
				<Route
					exact
					path='/nosotros'
					element={<Nosotros />}
				/>
				<Route
					exact
					path='/trabajos'
					element={<Trabajos />}
				/>
				<Route
					exact
					path='/contacto'
					element={<Contacto />}
				/>
				<Route
					exact
					path='/acreditacion'
					element={<Acreditacion />}
				/>
				<Route
					exact
					path='/avisoLegal'
					element={<AvisoLegal />}
				/>
				<Route
					exact
					path='/politicaCookies'
					element={<PoliticaCookies />}
				/>
				<Route
					exact
					path='/politicaPrivacidad'
					element={<PoliticaPrivacidad />}
				/>
				<Route
					exact
					path='/condicionesGenerales'
					element={<CondicionesGenerales />}
				/>
				<Route path='/:band' element={<TourDetail />} />
			</Routes>
			<Footer />
		</>
	);
};

export default App;
